import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { HelpersService } from '../../../../../services/helpers.service';
import { PartnerService } from '../../../../../services/partner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { ConfirmationService } from 'primeng/api';
import moment from 'moment';
import { Paginator } from 'primeng/paginator';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-cycle-shops',
  templateUrl: './cycle-shops.component.html',
  styleUrls: ['./cycle-shops.component.scss'],
  //encapsulation: ViewEncapsulation.None
})
export class CycleShopsComponent implements OnInit {
  public partners: any = [];
  public partnersFiltered: any = [];
  public loading: boolean = false;
  public columns: any = [
    { header: 'ID', field: 'id', type: 'string', width: '80px' },
    { header: 'Name', field: 'name', type: 'string', width: '230px' },
    { header: 'Status', field: 'statusID', type: 'status', width: '200px' },
    { header: 'Actions', field: 'actions', type: 'actions', width: '200px' },
    { header: 'Country', field: 'country', type: 'string', width: '80px' },
    //{ header: "Phone Number", field: "phoneNumber", type: 'string', width: '150px' },
    { header: 'Email', field: 'email', type: 'string', width: '240px' },
    {
      header: 'POS',
      field: 'posSystemID',
      type: 'posSystemID',
      width: '200px',
    },
    {
      header: 'Products',
      field: 'productsSyncd',
      type: 'productsSyncd',
      width: '150px',
    },
    {
      header: 'Customers',
      field: 'clientsSyncd',
      type: 'clientsSyncd',
      width: '150px',
    },
    { header: 'Services', field: 'services', type: 'string', width: '150px' },
    { header: 'Rentals', field: 'rentals', type: 'string', width: '150px' },
    {
      header: 'SMS Credits',
      field: 'smsCredits',
      type: 'string',
      width: '150px',
    },
  ];
  public syncBusy: boolean = false;
  public showSMS: boolean = false;
  public SMSCredits: string = '';
  public showTrial: boolean = false;
  public trialEndDate: Date;
  public selectedPartner: any = null;
  public page = 0;
  public limit = 10;
  public search = '';
  public status = '';
  public totalRecords = 0;
  public showEditStoreSubscription : boolean = false;
  private cancelRequest$ = new Subject<void>();

  constructor(
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private posIntegrationService: PosIntegrationService,
    public router: Router,
    public confirmationService: ConfirmationService,
  ) {}

  @ViewChild('paginator') paginator: Paginator;

  ngOnInit() {
    this.getPartners();
  }

  getPartners() {
    this.cancelRequest$.next();
    this.loading = true;
    this.partnerService
      .getPartnersV2(1, 10000, this.search)
      .pipe(
        takeUntil(this.cancelRequest$)
      )
      .subscribe((partners) => {
        this.totalRecords = partners.length; //This is a bit of a hack for now to get all the partners as the API does not return this info
        this.loading = false;
        //this.partners = partners;
        this.getPartnersDetail();
      });
  }

  getPartnersDetail() {
    this.cancelRequest$.next();
    this.loading = true;
    this.partnerService
      .getPartnersV2(this.page + 1, this.limit, this.search, true, this.status)
      .pipe(
        takeUntil(this.cancelRequest$)
      )
      .subscribe(
        (partners) => {
          this.loading = false;
          this.partners = partners;
          //this.filterList();
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  paginate(event) {
    this.page = event.page;
    this.limit = event.rows;
    this.getPartnersDetail();
  }

  searchPartners() {
    this.page = 0;
    if (this.search === '') {
      this.getPartners();
      if (!this.paginator.isFirstPage()) {
        setTimeout(() => {
          this.paginator.changePageToFirst({
            page: 0,
            rows: this.limit,
          } as any);
        }, 250);
      }
    } else {
      if (this.search.length > 3) {
        this.getPartners();
      }
    }
  }

  filterList() {
    if (this.status == '') {
      this.partnersFiltered = this.partners;
    } else {
      this.partnersFiltered = [];
      this.partners.forEach((x) => {
        if (x.statusID.toString() == this.status.toString())
          this.partnersFiltered.push(x);
      });
      console.log(this.status, this.partnersFiltered, this.partners);
    }
  }

  getPOSSystem(ID) {
    switch (ID) {
      case 4:
        return 'Sage Online';
        break;
      case 6:
        return 'Lightspeed R';
        break;
      case 3:
        return 'Lightspeed X';
        break;
      case 8:
        return 'Xero';
        break;
      case 9:
        return 'Shopify';
        break;
      case 10:
        return 'Dear';
        break;
      case 11:
        return 'Northmill';
        break;
      case 12:
        return 'Retail Express';
        break;
      case 13:
        return 'Citrus Lime';
        break;
      case 14:
        return 'EPOSNow';
        break;
      case 15:
        return 'Wilmar';
        break;
      case 16:
        return 'Netsuite';
        break;
      case 17:
        return 'Square';
        break;
      case 18:
        return 'Xentral';
        break;
      case 19:
        return 'Global Payments';
        break;
      case 20:
        return 'Teamwork';
        break;
      case 21:
        return 'Erply';
        break;
      case 22:
        return 'Ascend';
        break;
    }
    if (ID > 0) return 'Other';
    return 'N/A';
  }

  getStatus(ID, TrialEnds) {
    switch (ID) {
      case 2:
        return 'Expired - ' + moment(TrialEnds).fromNow();
        break;
      case 3:
        return 'Payment Missed';
        break;
      case 4:
        return 'Card Expired';
        break;
      case 20:
        return 'Cancellation In Progress';
        break;
      case 21:
        return 'Cancelled';
        break;
      case 50:
        return 'Active';
        break;
      case 51:
        return 'Demo Account';
        break;
    }
    if (ID === 1 && moment(TrialEnds).diff(new Date(), 'minutes') <= 0) {
      return 'Expired - ' + moment(TrialEnds).fromNow();
    } else if (ID === 1) {
      return (
        'Trial ' +
        ' - ' +
        moment(TrialEnds).diff(new Date(), 'days') +
        ' Day(s) left'
      );
    }
    return 'Unknown';
  }

  allowAddSMS(partner) {
    switch (partner.statusID) {
      case 2:
        return false;
        break;
      case 3:
        return true;
        break;
      case 4:
        return true;
        break;
      case 20:
        return true;
        break;
      case 21:
        return false;
        break;
      case 50:
        return true;
        break;
      case 51:
        return true;
        break;
    }
    if (
      partner.statusID === 1 &&
      moment(partner.trialEnds).diff(new Date(), 'minutes') <= 0
    ) {
      return false;
    } else if (partner.statusID === 1) {
      return true;
    }
    return false;
  }

  allowProductSync(partner) {
    var active = false;
    switch (partner.statusID) {
      case 2:
        active = false;
        break;
      case 3:
        active = true;
        break;
      case 4:
        active = true;
        break;
      case 20:
        active = true;
        break;
      case 21:
        active = false;
        break;
      case 50:
        active = true;
        break;
      case 51:
        active = true;
        break;
    }
    if (
      partner.statusID === 1 &&
      moment(partner.trialEnds).diff(new Date(), 'minutes') <= 0
    ) {
      active = false;
    } else if (partner.statusID === 1) {
      active = true;
    }
    return (
      [3, 6, 8, 4, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22].includes(
        partner.posSystemID,
      ) && active
    );
  }

  allowClientSync(partner) {
    var active = false;
    switch (partner.statusID) {
      case 2:
        active = false;
        break;
      case 3:
        active = true;
        break;
      case 4:
        active = true;
        break;
      case 20:
        active = true;
        break;
      case 21:
        active = false;
        break;
      case 50:
        active = true;
        break;
      case 51:
        active = true;
        break;
    }
    if (
      partner.statusID === 1 &&
      moment(partner.trialEnds).diff(new Date(), 'minutes') <= 0
    ) {
      active = false;
    } else if (partner.statusID === 1) {
      active = true;
    }
    return (
      [3, 6, 8, 4, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22].includes(
        partner.posSystemID,
      ) && active
    );
  }

  impersonate(partner) {
    this.helpersService.setActiveProduct(null);
    this.helpersService.setLastURL(null);
    this.helpersService.saveProductData([]); //Clear the product data when switching between partners
    var profile = this.helpersService.getProfileData();
    profile.PartnerID = partner.id;
    profile.isAdmin = true;
    this.helpersService.saveProfileData(profile);
    this.helpersService.savePartnerData(partner);
    this.router.navigateByUrl('store/product-redirect-loader');
  }

  initiateFullPOSResync(partner) {
    this.confirmationService.confirm({
      rejectVisible: true,
      rejectLabel: 'No',
      acceptLabel: 'Start Sync',
      header: 'Initiate Product Sync',
      message:
        'Are you sure you want to initiate a full product sync for ' +
        partner.name +
        '?',
      accept: () => {
        partner.syncBusy = true;
        this.posIntegrationService
          .startFullPOSSync(partner.id, partner.posSystemID)
          .subscribe((result) => {
            partner.syncBusy = false;
          });
      },
      reject: () => {},
    });
  }

  initiateFullClientResync(partner) {
    this.confirmationService.confirm({
      rejectVisible: true,
      rejectLabel: 'No',
      acceptLabel: 'Start Sync',
      header: 'Initiate Client Sync',
      message:
        'Are you sure you want to initiate a full client sync for ' +
        partner.name +
        '?',
      accept: () => {
        partner.syncBusy = true;
        this.posIntegrationService
          .startPOSClientSync(partner.id, partner.posSystemID)
          .subscribe((result) => {
            partner.syncBusy = false;
          });
      },
      reject: () => {},
    });
  }

  showSMSPopup(partner) {
    this.selectedPartner = partner;
    this.SMSCredits = '';
    this.showSMS = true;
  }

  editStoreSubscription(partner){
    this.selectedPartner = partner;
    this.showEditStoreSubscription = true;
  }

  addSMSCredits() {
    if (this.selectedPartner && this.selectedPartner.id) {
      var data = {
        PartnerID: this.selectedPartner.id,
        SMSCredits: this.SMSCredits,
      };
      this.partnerService.addSMSCredits(data).subscribe(
        () => {
          this.selectedPartner = null;
          this.SMSCredits = '';
          this.showSMS = false;
          this.getPartnersDetail();
        },
        (err) => {},
      );
    }
  }

  showTrialExtendPopup(partner) {
    this.selectedPartner = partner;
    this.trialEndDate = null;
    this.showTrial = true;
  }

  updateTrailPeriod() {
    if (this.selectedPartner && this.selectedPartner.id) {
      var data = {
        PartnerID: this.selectedPartner.id,
        TrailEndDate: moment(this.trialEndDate).format('YYYY-MM-DD'),
      };
      this.partnerService.extendTrial(data).subscribe(
        () => {
          this.selectedPartner = null;
          this.trialEndDate = null;
          this.showTrial = false;
          this.getPartnersDetail();
        },
        (err) => {},
      );
    }
  }
}
